export default __webpack_public_path__ + "static/media/kitchen1-1440w.6916901f.avif";